import React, { useEffect, useState } from "react";
import BrandCard from "./BrandCard";
import { api } from "@/lib/api";

export default function BrandsGrid() {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/brands")
      .then((r) => setBrands(r.data))
      .catch(() => setBrands([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section id="brands" className="py-20 lg:py-28" data-testid="brands-section">
      <div className="container-nk">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <p className="eyebrow">// The Hub</p>
            <h2 className="font-display text-[56px] md:text-[80px] leading-[0.95] mt-3">
              Meet the Brands
            </h2>
          </div>
          <p className="text-muted text-[15px] max-w-md font-light leading-relaxed">
            Twenty independent food brands. Twenty kitchens. Pick your craving,
            pick your platform — or walk straight up to the counter.
          </p>
        </div>

        {loading ? (
          <div className="text-muted font-mono text-sm py-20 text-center" data-testid="brands-loading">
            Loading brands…
          </div>
        ) : (
          <div
            className="grid gap-4"
            style={{
              gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
            }}
            data-testid="brands-grid"
          >
            {brands.map((b) => (
              <BrandCard key={b.id} brand={b} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
